// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'

/**
 * This feature is created to be used when for instance an image is covering a video
 * or the video is in an overflow hidden container that dictates it's dimensions
 * and we want to show the outline when the video is focused for accessibility reasons.
 *
 * @example
 * <div class="js-outline-target" data-outline-active="false">
 *  <video class="js-outline-source"></video>
 * </div>
 */
observe('.js-outline-source', element => {
  element.addEventListener('focus', () => {
    const target = element.closest('.js-outline-target')
    target?.setAttribute('data-outline-active', 'true')
  })

  element.addEventListener('blur', () => {
    const target = element.closest('.js-outline-target')
    target?.removeAttribute('data-outline-active')
  })
})
